import React, { useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Colors } from 'react-native-paper';
import Icon from 'react-native-vector-icons/Ionicons';
import { useDispatch, useSelector } from 'react-redux';
import { Header } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import styles from './styles';
import { pixelDimensions } from '../../../config/utils';
import { confirmRating } from '../../../redux/actions/trainerActions';

export default function Evaluation({ navigation, route }) {
  const { id_aula } = route.params;
  const dispatch = useDispatch();
  const { trainerData } = useSelector((state) => state.trainer);
  const [rateQuality, setRatePersonal] = useState(0);
  const [rateDifficulty, setRateDifficulty] = useState(0);

  const showStars = (stars, isPersonal) => {
    const starsCont = [];
    for (let i = 0; i < 5; i++) {
      starsCont[i] = i < stars ? '+' : '-';
    }
    return starsCont.map((s, index) => (
      <TouchableOpacity key={`star-${isPersonal ? 'per' : 'prof'}-${index}`} onPress={() => (isPersonal ? setRatePersonal(index + 1) : setRateDifficulty(index + 1))}>
        <Icon name={`star${s === '+' ? '' : '-outline'}`} size={pixelDimensions(10)} color={s === '+' ? Colors.yellow800 : Colors.black} />
      </TouchableOpacity>
    ));
  };
  const handleConfirmRating = () => {
    const { id_profissional } = trainerData;
    const postData = {
      id_profissional,
      id_aula,
      nota_qualidade: rateQuality,
      nota_dificuldade: rateDifficulty,
    };
    dispatch(confirmRating(postData, navigation));
  };
  return (
    <>
      <Header
        canAlterPic="Company Alter Pic"
        profilePic={trainerData.foto}
        navigation={navigation}
        userName={trainerData.nome}
      />
      <View style={styles.container}>
        <AppText style={styles.textTitle}>Avaliação</AppText>
        <View style={styles.viewEvaluation}>
          <AppText style={styles.textSubTitle}>Qualidade</AppText>
          <View style={{ flexDirection: 'row' }}>
            {showStars(rateQuality, true)}
          </View>
        </View>
        <View style={styles.viewEvaluation}>
          <AppText style={styles.textSubTitle}>Dificuldade</AppText>
          <View style={{ flexDirection: 'row' }}>
            {showStars(rateDifficulty, false)}
          </View>
        </View>
        <AppButton size="bold" style={styles.buttonConfirm} labelStyle={styles.textBack} label="Confirmar Avaliação" onPress={handleConfirmRating} />
        <AppButton size="bold" label="VOLTAR" style={styles.buttonBack} labelStyle={styles.textBack} onPress={() => navigation.goBack()} />
      </View>
    </>
  );
}
